/**
 * Finnish bank account helpers — mirror of verstaani/utils/bank.py.
 *
 * A Finnish IBAN identifies its bank: FI + 2 check digits + a 14-digit BBAN whose first six
 * digits are the clearing number. A BIC that contradicts the IBAN makes the recipient's bank
 * reject the e-invoice, so the settings form points the mismatch out while it is still easy
 * to fix. Only unambiguous clearing ranges are listed — the 4xxxxx range is shared by several
 * banks, so an unknown prefix means "cannot tell", never "wrong".
 */

const FINNISH_BANK_BICS = {
  1: 'NDEAFIHH', // Nordea
  2: 'NDEAFIHH', // Nordea
  31: 'HANDFIHH', // Handelsbanken
  38: 'SWEDFIHH', // Swedbank
  39: 'SBANFIHH', // S-Pankki
  5: 'OKOYFIHH', // OP (Osuuspankit)
  6: 'AABAFI22', // Ålandsbanken
  8: 'DABAFIHH', // Danske Bank
};

const FINNISH_IBAN_LENGTH = 18;

export const normalizeBankCode = (value) => (value || '').replace(/\s/g, '').toUpperCase();

/** The BIC a Finnish IBAN implies, or '' when it cannot be determined. */
export const expectedBicForIban = (iban) => {
  const normalized = normalizeBankCode(iban);
  if (!normalized.startsWith('FI') || normalized.length !== FINNISH_IBAN_LENGTH) return '';
  if (!/^\d+$/.test(normalized.slice(2))) return '';

  const clearing = normalized.slice(4, 10);
  return FINNISH_BANK_BICS[clearing.slice(0, 2)] || FINNISH_BANK_BICS[clearing.slice(0, 1)] || '';
};

/** Whether this BIC contradicts the bank its IBAN belongs to. False whenever we cannot tell. */
export const bicConflictsWithIban = (iban, bic) => {
  const normalizedBic = normalizeBankCode(bic);
  const expected = expectedBicForIban(iban);
  if (!normalizedBic || !expected) return false;
  return normalizedBic.slice(0, 8) !== expected.slice(0, 8);
};
